// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3j9tA","disabled":"FileBtn_disabled__Q6wXg","warn":"FileBtn_warn__1xZoV","fade":"FileBtn_fade__1Pwpa"};